import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../../app/api/routes';
import { ORGANISATION_CONTACT_RESOURCE } from '../../constants';

const OrganisationContactService = ComposedComponent =>
  reduxFetch([
    {
      resource: ORGANISATION_CONTACT_RESOURCE,
      method: 'get',
      request: (orgId, contactId, rejectCallback) => ({
        url: apiRoutes.organisationContacts(orgId, contactId),
        meta: { rejectCallback },
      }),
    },
  ])(ComposedComponent);

export default OrganisationContactService;
